// removed by extract-text-webpack-plugin
module.exports = {"heading":"src-components-BlockTitle----BlockTitle-module---heading---Gu5et","red":"src-components-BlockTitle----BlockTitle-module---red---21ofs","blue":"src-components-BlockTitle----BlockTitle-module---blue---25wLF","opaque":"src-components-BlockTitle----BlockTitle-module---opaque---1HVUV","small":"src-components-BlockTitle----BlockTitle-module---small---2dTDk","medium":"src-components-BlockTitle----BlockTitle-module---medium---2FAq0","large":"src-components-BlockTitle----BlockTitle-module---large---3TBM2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BlockTitle/BlockTitle.module.scss
// module id = 1164
// module chunks = 168707334958949